import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TopBarActions } from "src/redux/TopBar/actions";
import { VIEWS } from "src/redux/TopBar/constants";
import styles from "./styles.module.scss";
import Positions from "./Positions";
import Collateral from "./Collateral";
import Billing from "./Billing";
import CorporateActions from "./CorporateActions";

const POST_TRADE_TABS = {
    positions: { key: "positions", label: "Positions", component: Positions },
    collateral: {
        key: "collateral",
        label: "Collateral",
        component: Collateral,
    },
    billing: { key: "billing", label: "Billing", component: Billing },
    corporateActions: {
        key: "corporateActions",
        label: "Corporate Actions",
        component: CorporateActions,
    },
};

const PostTrade = () => {
    const dispatch = useDispatch();

    const [activeTab, setActiveTab] = useState(POST_TRADE_TABS.positions.key);

    useEffect(() => {
        dispatch(TopBarActions.SetView(VIEWS.POST_TRADE));
    }, [dispatch]);

    return (
        <div className={styles.postTrade}>
            <div className={styles.header}>
                <div className={styles.title}>Post Trade</div>
            </div>
            <div className={styles.nav}>
                <Tabs
                    activeTab={activeTab}
                    tabOptions={POST_TRADE_TABS}
                    onTabChange={setActiveTab}
                />
            </div>
            <div className={styles.body}>
                {React.createElement(POST_TRADE_TABS[activeTab].component)}
            </div>
        </div>
    );
};

const Tabs = ({ activeTab, tabOptions, onTabChange }) => {
    return (
        <>
            {Object.values(tabOptions).map((tab) => (
                <button
                    key={tab.key}
                    onClick={() => onTabChange(tab.key)}
                    className={`${styles.tabBtn}${
                        activeTab === tab.key ? ` ${styles.active}` : ""
                    }`}
                >
                    {tab.label}
                </button>
            ))}
        </>
    );
};

export default PostTrade;
